import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShellEventsService {
  /** Emit 'editDairy' to ask the shell to open the Edit Dairy dialog */
  readonly events$ = new Subject<'editDairy'>();

  openEditDairy(): void {
    this.events$.next('editDairy');
  }
}
